import TransactionContainer from "./TransactionContainer";
import TransactionStore from "./TransactionStore";

export default TransactionStore(TransactionContainer);